// core/akunkas.cache — daftar akun kas yang siap dibaca SERENTAK oleh layar kasir.
//
// Pilihan "cara bayar" muncul di tengah melayani pelanggan (terima DP, serah terima, pelunasan).
// Kalau daftarnya diambil dari jaringan saat itu juga, dropdown-nya sempat kosong dan kasir bisa
// menyimpan nota tanpa metode — persis lubang yang membuat tutup kasir tak pernah klop. Karena
// itu dimuat sekali setelah masuk, lalu dibaca dari ingatan.
import { supabase } from '@core/supabase';
import { CARA_PIUTANG } from '@domain/money';

export interface AkunRingkas { id: number; nama: string; jenis: string; outlet: string | null; urut: number }

let cache: AkunRingkas[] = [];
let sudah = false;

export async function loadAkunKas(): Promise<boolean> {
  try {
    const { data, error } = await supabase().from('cash_accounts')
      .select('id,nama,jenis,outlet,urut').eq('aktif', true).order('urut').order('id');
    if (error) throw new Error(error.message);
    cache = (data ?? []) as AkunRingkas[];
    sudah = true;
    return true;
  } catch { return false; }
}

export const akunKasCache = (outlet?: string | null): AkunRingkas[] =>
  cache.filter((a) => !a.outlet || !outlet || a.outlet === outlet);

/**
 * Pilihan cara bayar untuk kasir: nama tiap akun kas + opsi piutang.
 *
 * Belum ada akun kas (atau gagal dimuat) → JATUH ke daftar lama Tunai/Transfer/QRIS. Toko harus
 * tetap bisa menerima uang walau pengaturannya belum disiapkan; yang hilang cuma kemampuan
 * membedakan dua rekening.
 */
export function caraBayarOpsi(outlet?: string | null): string[] {
  const akun = akunKasCache(outlet).map((a) => a.nama);
  const dasar = sudah && akun.length ? akun : ['Tunai', 'Transfer', 'QRIS'];
  return [...dasar, ...CARA_PIUTANG];
}
